import { Component } from 'react';
import { GoogleLogin } from 'react-google-login';
import { connect } from 'react-redux';

import { googleLoginOrCreate } from 'redux/customer/actions';

class GoogleLoginButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessage: null
    };
  }

  handleGoogleFailure = (response) => {
    // eslint-disable-next-line no-console
    console.log(response);
    // this.setState({ showMessage: 'Error' });
  };

  handleGoogleLogin = (response) => {
    const { props } = this;
    const errorFunction = () => {
      this.setState({ showMessage: 'Error' });
    };
    const successFunction = () => {
      const { onRedirect } = this.props;
      onRedirect();
    };
    props.googleLoginOrCreate(response.tokenId, successFunction, errorFunction);
  };

  render() {
    const { showMessage } = this.state;
    const { settings } = this.props;
    return (
      <>
        {showMessage === 'Error' && (
          <div className="c7-message--error">Error: Invalid Google Login</div>
        )}
        <GoogleLogin
          clientId={settings.data.googleLogin.clientId}
          // buttonText="Login With Google"
          onSuccess={this.handleGoogleLogin}
          onFailure={this.handleGoogleFailure}
          cookiePolicy="single_host_origin"
          theme="dark"
          className="c7-icon c7-icon--google"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps, { googleLoginOrCreate })(
  GoogleLoginButton
);
